export default "__VITE_ASSET__BvPA6coQ__"